import { BadImplementationException } from '@nu-art/ts-common';
import { NumericDBValueTypes, StringDBValueTypes } from '../consts.js';
import { resolveAssociatedEntity } from '../utils.js';
import { booleanExpressionTypes, numericExpressionTypes, rangeExpressionTypes } from '../../../../_entity/index.js';
export const resolveSelf = (dbAtom, dependencies) => {
    const selfEvalLogic = {};
    selfEvalLogic.type = 'default (self)';
    const entity = resolveAssociatedEntity(dbAtom, dependencies);
    if (entity) {
        if ('name' in entity)
            resolveSelfForHVAtom(entity, selfEvalLogic, dependencies);
        else
            resolveSelfForEmbeddedExpression(entity, selfEvalLogic, dependencies);
    }
    return selfEvalLogic;
};
const resolveSelfForHVAtom = (entity, selfEvalLogic, dependencies) => {
    const dbValue = dependencies.values.find(_val => _val._id === entity.valueId);
    if (!dbValue)
        throw new BadImplementationException(`No value found for id ${entity.valueId}`);
    if (StringDBValueTypes.includes(dbValue.type))
        selfEvalLogic.output_type = 'string';
    else if (NumericDBValueTypes.includes((dbValue.type)))
        selfEvalLogic.output_type = 'number';
    else
        throw new BadImplementationException(`Cannot resolve output type for value type ${dbValue.type}`);
};
const resolveSelfForEmbeddedExpression = (entity, selfEvalLogic, dependencies) => {
    if (booleanExpressionTypes.includes(entity.expressionType))
        selfEvalLogic.output_type = 'string';
    if (numericExpressionTypes.includes(entity.expressionType))
        selfEvalLogic.output_type = 'number';
    if (rangeExpressionTypes.includes(entity.expressionType))
        selfEvalLogic.output_type = 'tuple';
};
//# sourceMappingURL=self.js.map